// @ts-nocheck

const TEMP_SINGLE_SELECTION_MODE = true; // Mientras dure la limitación temporal

const TREATMENTS_STEP_CONFIG = {
  // Dominio por defecto de la tienda (se usa como fallback)
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',

  // Tag que identifica los productos de tratamientos
  TAG_TREATMENT: 'extra-type',

  // Número máximo de productos a recuperar desde la API de products.json
  PRODUCTS_LIMIT: 250,

  // Orden preferido para renderizar opciones (claves esperadas en el mapping)
  // Nota: aquí debemos usar las keys internas de tratamientos (no los handles)
  // para que el reordenado posterior coincida con las claves que produce
  // getBasicTreatments() / mapProductToTreatmentKey(). Ajustamos para que
  // la primera opción sea el cristal de la tienda 'cristal-ainy-more'
  // (key interna 'ainy') y la última sea 'photocromatic'.
  PREFERRED_ORDER: ['ainy', 'estandar', 'blue_filter', 'photocromatic'],

  // Multi-select para este step (true = multi-select)
  MULTI_SELECT: true,

  // Si true, usar getBasicTreatments() cuando no se encuentren productos
  USE_BASIC_FALLBACK: true,
  // Controla si las opciones deben mostrar imagen de producto cuando esté disponible
  MOSTRAR_IMAGENES_PRODUCTO: false,
  // Si true, intentar inferir treatment keys desde title/tags cuando no haya mapeo por handle
  USE_INFERENCE: false
};

// -----------------------------
/**
 * Step específico: Tratamientos del Cristal
 */
class TreatmentsStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    super(configurator, {
      ...options,
      stepKey: 'treatments',
      title: 'Tratamientos',
      description: 'Selecciona los tratamientos adicionales'
    });
    // No cargar automáticamente aquí; init() se llamará cuando el step sea mostrado
  }

  static get STEP_CONFIG() {
    return TREATMENTS_STEP_CONFIG;
  }

  async init() {
    if (typeof this.loadConfiguration === 'function') {
      await this.loadConfiguration();
    }
  }

  /**
   * Obtiene la URL correcta para las peticiones a Shopify
   */
  getShopifySearchUrl() {
    const shopDomain = this.getShopifyDomain();
    return `https://${shopDomain}/products.json?limit=${TreatmentsStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
  }

  getCurrentLocale() {
    if (this.configurator && this.configurator.locale) return this.configurator.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale && ogLocale.content) return ogLocale.content;
    return null;
  }

  buildShopifyProductsUrl(query) {
    const shopDomain = this.getShopifyDomain();
    const locale = this.getCurrentLocale();
    let url = `https://${shopDomain}/products.json?limit=${TreatmentsStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
    if (query && typeof query === 'string') {
      const q = query.replace(/^\?/, '');
      if (q) url += `&${q}`;
    }
    if (locale) url += `&locale=${encodeURIComponent(locale)}`;
    return url;
  }

  /**
   * Detecta el dominio de la tienda Shopify
   */
  getShopifyDomain() {
    if (this.configurator && this.configurator.shopDomain) return this.configurator.shopDomain;
    if (window.__AINY_SHOP_DOMAIN) return window.__AINY_SHOP_DOMAIN;
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }
    return TreatmentsStep.STEP_CONFIG.SHOP_DOMAIN || 'gf7q0f-ma.myshopify.com';
  }

  async loadConfiguration() {
    if (!this.configurator.config) {
      this.configurator.config = {};
    }
    
    this.configurator.config.treatments = await this.loadTreatmentsFromShopify();

    try { this.render(); } catch (e) { console.warn('⚠️ Error al re-renderizar TreatmentsStep:', e); }
  }

  /**
   * Carga los tratamientos dinámicamente desde productos de Shopify
   */
  async loadTreatmentsFromShopify() {
    try {
      // Construir lista de tags a buscar
      const tags = TreatmentsStep.STEP_CONFIG.TAGS && TreatmentsStep.STEP_CONFIG.TAGS.length ? TreatmentsStep.STEP_CONFIG.TAGS : [TreatmentsStep.STEP_CONFIG.TAG];

      // Obtener la URL base de products.json
      const domain = this.getShopifyDomain();
      const url = (window.LensStepUtils && typeof window.LensStepUtils.buildProductsUrl === 'function')
        ? window.LensStepUtils.buildProductsUrl(domain, TreatmentsStep.STEP_CONFIG.PRODUCTS_LIMIT)
        : this.getShopifySearchUrl();

      console.log('🔍 Consultando productos de Shopify (products.json):', url, 'filter tags:', tags);

      // Patrón consistente con lens-step-type: usar fetchProductsByTag si existe
      const tag = TreatmentsStep.STEP_CONFIG.TAG_TREATMENT || TreatmentsStep.STEP_CONFIG.TAG || 'extra-type';
      let products = [];
      if (window.LensStepUtils && typeof window.LensStepUtils.fetchProductsByTag === 'function') {
        products = await window.LensStepUtils.fetchProductsByTag(this.configurator, tag, TreatmentsStep.STEP_CONFIG.PRODUCTS_LIMIT);
        console.log('🔎 Productos encontrados via LensStepUtils.fetchProductsByTag:', products.length);
      } else {
        // Fallback: fetch products.json y filtrar por tag explícito
        const productsUrl = this.buildShopifyProductsUrl(`?q=tag:${encodeURIComponent(tag)}`);
        console.log('🔍 (fallback) Consultando productos de Shopify:', productsUrl);
        const resp = await fetch(productsUrl);
        if (!resp.ok) throw new Error(`HTTP ${resp.status}: ${resp.statusText}`);
        const dd = await resp.json();
        const allProducts = dd.products || [];
        products = allProducts.filter(p => {
          if (!p) return false;
          let pt = p.tags || '';
          if (Array.isArray(pt)) pt = pt.join(' ');
          return String(pt).toLowerCase().includes(String(tag).toLowerCase());
        });
        console.log('🔎 (fallback) productos filtrados por tag:', products.length);
      }

      if (!products || products.length === 0) {
        console.warn('⚠️ No se encontraron productos con tag "' + tag + '"');
        return this.getBasicTreatments();
      }

      const treatments = {};
      const productsList = products;
      productsList.forEach(product => {
        let treatmentKey = this.mapProductToTreatmentKey(product.handle);

        // Si no hay mapping por handle y la configuración lo permite, intentar inferir
        if (!treatmentKey && TreatmentsStep.STEP_CONFIG.USE_INFERENCE) {
          treatmentKey = this.inferTreatmentKeyFromProduct(product);
        }

  if (treatmentKey) {
          const price = (window.LensStepUtils && typeof window.LensStepUtils.parsePrice === 'function')
            ? window.LensStepUtils.parsePrice(product)
            : this.parsePrice(product);

          treatments[treatmentKey] = {
            name: product.title,
            description: this.extractProductDescription(product),
            price: price,
            productId: product.id,
            handle: product.handle,
            image: product.images && product.images.length > 0 ? product.images[0].src : null,
            variants: product.variants
          };
        } else {
          console.debug('ℹ️ Producto encontrado pero no mapeado a treatmentKey (handle/title):', product.handle, product.title);
        }
      });

      // Si no encontramos suficientes tratamientos, intentar escanear todos los productos
      // (algunos productos podrían no tener las tags esperadas pero sí contener palabras clave en title/handle)
      const expectedCount = TreatmentsStep.STEP_CONFIG.PREFERRED_ORDER.length;
      const currentCount = Object.keys(treatments).length;
      if (currentCount < expectedCount) {
        console.warn('⚠️ Se encontraron menos tratamientos de los esperados. Buscando en los productos encontrados para inferir más...');
        for (const p of productsList) {
          if (!p) continue;
          // evitar remapear si ya está en tratamientos
          const already = Object.values(treatments).some(t => t.handle === p.handle);
          if (already) continue;

          let tk = this.mapProductToTreatmentKey(p.handle) || this.inferTreatmentKeyFromProduct(p);
          if (tk && !treatments[tk]) {
            const price = (window.LensStepUtils && typeof window.LensStepUtils.parsePrice === 'function')
              ? window.LensStepUtils.parsePrice(p)
              : this.parsePrice(p);

            treatments[tk] = {
              name: p.title,
              description: this.extractProductDescription(p),
              price: price,
              productId: p.id,
              handle: p.handle,
              image: p.images && p.images.length > 0 ? p.images[0].src : null,
              variants: p.variants
            };
            console.log('➕ Añadido tratamiento inferido desde productos (fallback):', tk, 'handle:', p.handle);
          }

          if (Object.keys(treatments).length >= expectedCount) break;
        }
      }

      if (Object.keys(treatments).length === 0) {
        console.warn('⚠️ No se pudieron mapear productos válidos para tratamientos');
        console.warn('🔧 Usando configuración básica por defecto');
        if (TreatmentsStep.STEP_CONFIG.USE_BASIC_FALLBACK) return this.getBasicTreatments();
        return {};
      }

      // Reordenar según PREFERRED_ORDER para presentación consistente
      const ordered = {};
      const order = TreatmentsStep.STEP_CONFIG.PREFERRED_ORDER || Object.keys(treatments);
      order.forEach(k => {
        if (treatments[k]) ordered[k] = treatments[k];
      });
      // Añadir el resto que no estén en PREFERRED_ORDER
      Object.keys(treatments).forEach(k => { if (!ordered[k]) ordered[k] = treatments[k]; });

      console.log('✅ Tratamientos cargados desde Shopify (ordenados):', ordered);
      return ordered;
    } catch (error) {
      console.error('❌ Error cargando tratamientos desde Shopify:', error);
      console.warn('🔧 Usando configuración básica por defecto hasta que se resuelva el problema');
      return this.getBasicTreatments();
    }
  }

  /**
   * Intenta inferir la key del tratamiento desde el título o tags del producto
   */
  inferTreatmentKeyFromProduct(product) {
  if (!product) return null;
  const title = (product.title || '').toLowerCase();
  let tagsRaw = product.tags || '';
  if (Array.isArray(tagsRaw)) tagsRaw = tagsRaw.join(' ');
  const tags = String(tagsRaw).toLowerCase();

  // Antirreflejo / anti-reflective
  if (title.includes('antirreflejo') || title.includes('antirreflec') || title.includes('anti-reflect') || tags.includes('antireflective') || tags.includes('antirreflejo') || tags.includes('anti-reflective')) return 'estandar';

    // Fotocromático / photochromic / photochromatic
    if (title.includes('fotocrom') || title.includes('fotocromático') || title.includes('photochrom') || title.includes('photochromic') || title.includes('photochromatic') || tags.includes('photocrom') || tags.includes('photochrom') ) return 'photocromatic';

    // Protección UV
    if (title.includes('uv') || title.includes('proteccion uv') || title.includes('protección uv') || tags.includes('uv') || tags.includes('proteccion uv')) return 'uv';

  // Hidrofóbico / hydrophobic / hydrophobic coating
  if (title.includes('hidrofob') || title.includes('hidrofóbico') || title.includes('hydrophobic') || title.includes('hydrophobic coating') || tags.includes('hydrophobic') || tags.includes('hidrofobico')) return 'ainy';

    // Filtro luz azul / blue filter
    if (title.includes('luz azul') || title.includes('blue light') || title.includes('blue-filter') || title.includes('blue filter') || tags.includes('blue') || tags.includes('blue light') || tags.includes('bluefilter') || tags.includes('blue-filter')) return 'blue_filter';

    return null;
  }

  /**
   * Mapea el handle de un producto a la key correspondiente del tratamiento
   */
  mapProductToTreatmentKey(handle) {
    // Mapeo de handles (producto.handle) a las keys internas usadas por el
    // step. Añade aquí cualquier variante de handle que uses en Shopify.
    // Reglas:
    // - Las claves del objeto son los "handles" exactos del producto en
    //   Shopify (sin dominio ni path).
    // - Los valores son las keys internas que usará la UI y que deben
    //   coincidir con TREATMENTS_STEP_CONFIG.PREFERRED_ORDER y con las
    //   keys devueltas por getBasicTreatments().
    const mappings = {
      // Ejemplos en español/variantes comunes
      'tratamiento-antirreflejo': 'antireflective',
      'tratamiento-fotocromatico': 'photocromatic',
      // Formas más cortas o sin prefijo
      'antirreflejo': 'antireflective',
      'fotocromatico': 'photocromatic',
      // Handles reales de la tienda (mapeo añadido según productos proporcionados)
      'cristal-fotocromatico': 'photocromatic',
      'cristal-ainy-more': 'ainy',
      'cristal-bloqueo-azul': 'blue_filter',
      'cristal-estandar': 'estandar'
    };
    return mappings[handle] || null;
  }

  /**
   * Extrae la descripción del producto
   */
  extractProductDescription(product) {
    if (product.body_html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = product.body_html;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      const firstSentence = text.split('.')[0];
      return firstSentence.length > 100 ? text.substring(0, 100) + '...' : firstSentence + '.';
    }
    return 'Descripción no disponible';
  }

  /**
   * Muestra un mensaje de error en el contenedor
   */
  showError(message) {
    const container = document.getElementById('treatment-options');
    if (!container) return;
    
    container.innerHTML = `
      <div class="error-message" style="
        background: #fee;
        border: 1px solid #fcc;
        color: #c33;
        padding: 15px;
        text-align: center;
        margin: 20px 0;
      ">
        <strong>Error:</strong> ${message}
      </div>
    `;
  }

  /**
   * Devuelve configuración básica de tratamientos por defecto
   */
  getBasicTreatments() {
    console.warn('⚠️ ATENCIÓN: Usando configuración básica por defecto. Para producción, crea productos en Shopify con tag "lens-treatment"');
    
    return {
      none: { 
        name: 'Sin Tratamiento', 
        price: 0, 
        description: 'Sin tratamientos adicionales. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      },
      estandar: { 
        name: 'Antirreflejo', 
        price: 25, 
        description: 'Reduce reflejos y mejora la visión nocturna. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      },
      photocromatic: { 
        name: 'Fotocromático', 
        price: 45, 
        description: 'Se oscurece con la luz UV para protección solar. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      },
      uv: { 
        name: 'Protección UV', 
        price: 15, 
        description: 'Bloquea rayos UV dañinos. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      },
      ainy: { 
        name: 'Hidrofóbico', 
        price: 20, 
        description: 'Repela agua y facilita la limpieza. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      }
    };
  }

  render() {
    const container = document.getElementById('treatment-options');
    if (!container) return;
    if (!this.configurator.config || !this.configurator.config.treatments || Object.keys(this.configurator.config.treatments).length === 0) {
      console.warn('⚠️ Tratamientos no cargados dinámicamente — usando configuración básica por defecto.');
      this.configurator.config = this.configurator.config || {};
      this.configurator.config.treatments = this.getBasicTreatments();
    }

    this.normalizeExistingSelection();

    container.innerHTML = '';
    const allowMultiple = !TEMP_SINGLE_SELECTION_MODE && Boolean(TreatmentsStep.STEP_CONFIG.MULTI_SELECT);
    Object.entries(this.configurator.config.treatments).forEach(([key, treatment]) => {
      const card = this.createOptionCard(key, treatment, 'treatments', allowMultiple);
      container.appendChild(card);

      // Si es el tratamiento photocromatic, añadir selector de color dentro del card
      if (key === 'photocromatic') {
        try {
          const colorsWrap = document.createElement('div');
          colorsWrap.className = 'photocromatic-colors';
          // Oculto por defecto: solo se muestra cuando el usuario selecciona la tarjeta
          colorsWrap.style.cssText = 'display:none; gap:12px; margin-top:12px; align-items:center;';

          const info = document.createElement('div');
          info.textContent = 'Elige color del cristal:';
          info.style.cssText = 'font-size:13px; color:#444; margin-right:8px;';
          colorsWrap.appendChild(info);

          // Preferir el mapa global si está presente para mantener coherencia con el cart drawer
          // Pero asegurar defaults inline robustos en caso de que el asset compartido no sea accesible
          const DEFAULT_PHOTOCROMATIC_MAP = { verde: '#2ecc71', marron: '#8b5e3c', gris: '#6b7280' };
          const DEFAULT_PHOTOCROMATIC_LABEL = { verde: 'Verde', marron: 'Marrón', gris: 'Gris' };
          const GLOBAL_MAP = (typeof window !== 'undefined') ? Object.assign({}, DEFAULT_PHOTOCROMATIC_MAP, window.PHOTOCROMATIC_COLOR_MAP || {}) : DEFAULT_PHOTOCROMATIC_MAP;
          const GLOBAL_LABEL = (typeof window !== 'undefined') ? Object.assign({}, DEFAULT_PHOTOCROMATIC_LABEL, window.PHOTOCROMATIC_COLOR_LABEL || {}) : DEFAULT_PHOTOCROMATIC_LABEL;

          const colors = [
            { key: 'verde', label: GLOBAL_LABEL['verde'], color: GLOBAL_MAP['verde'] },
            { key: 'marron', label: GLOBAL_LABEL['marron'], color: GLOBAL_MAP['marron'] },
            { key: 'gris', label: GLOBAL_LABEL['gris'], color: GLOBAL_MAP['gris'] }
          ];

          // Crear botones circulares representando cristales
          colors.forEach(c => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'photocromatic-color-btn';
            btn.dataset.color = c.key;
            btn.title = c.label;
            btn.style.cssText = `width:44px; height:44px; border-radius:50%; border:2px solid transparent; background:${c.color}; cursor:pointer; box-shadow:0 3px 8px rgba(0,0,0,0.12);`;

            // Inner pseudo-gloss circle for realism
            const gloss = document.createElement('span');
            gloss.style.cssText = 'display:block; width:70%; height:70%; border-radius:50%; background:rgba(255,255,255,0.12); margin:auto; margin-top:6px;';
            btn.appendChild(gloss);

            colorsWrap.appendChild(btn);

            btn.addEventListener('click', (ev) => {
              ev.preventDefault(); ev.stopPropagation();
              // Marcar visualmente
              const allBtns = card.querySelectorAll('.photocromatic-color-btn');
              allBtns.forEach(b => { b.style.borderColor = 'transparent'; b.style.transform = 'none'; });
              btn.style.borderColor = '#000';
              btn.style.transform = 'translateY(-2px) scale(1.03)';

              // Registrar selección en configurator
              try {
                // Para multi-select mantenemos un array; este step puede ser single-select semanticamente
                if (!this.configurator.configuration) this.configurator.configuration = {};
                this.configurator.configuration.treatments = this.configurator.configuration.treatments || [];
                // Asegurarnos de no duplicar
                if (!this.configurator.configuration.treatments.includes('photocromatic')) {
                  this.configurator.configuration.treatments.push('photocromatic');
                }
                // Guardar color seleccionado
                this.configurator.configuration.photocromatic_color = c.key;
              } catch (e) {}

              // Ahora sí podemos avanzar al siguiente paso
              try {
                if (this.configurator && typeof this.configurator.nextStep === 'function') {
                  setTimeout(() => this.configurator.nextStep(), 200);
                }
              } catch (e) {}
            });
          });

          // Añadir debajo de la descripción (inicialmente oculto)
          const descEl = card.querySelector('.option-description') || card.querySelector('.option-header');
          if (descEl && descEl.parentNode) descEl.parentNode.insertBefore(colorsWrap, descEl.nextSibling);

          // Mostrar selector únicamente cuando la tarjeta esté seleccionada
          card.addEventListener('click', (ev) => {
            // Evitamos que clicks internos en los botones de color vuelvan a propagar
            ev.stopPropagation();
            try {
              this.handleOptionSelect(card);
            } catch (e) {}
            // Mostrar/ocultar selector según estado seleccionado de la tarjeta
            const isSel = card.classList.contains('selected');
            colorsWrap.style.display = isSel ? 'flex' : 'none';
          });

          // Si ya existe selección previa en configurator, restaurar estado y mostrar selector
          try {
            const cfg = this.configurator && this.configurator.configuration ? this.configurator.configuration : null;
            const wasSelected = cfg && Array.isArray(cfg.treatments) && cfg.treatments.includes('photocromatic');
            if (wasSelected) {
              // Marcar tarjeta seleccionada
              try { card.classList.add('selected'); card.setAttribute('aria-selected', 'true'); } catch(e){}
              colorsWrap.style.display = 'flex';
              // Si hay color previamente guardado, marcarlo
              const prevColor = cfg.photocromatic_color;
              if (prevColor) {
                const btn = colorsWrap.querySelector(`.photocromatic-color-btn[data-color="${prevColor}"]`);
                if (btn) {
                  btn.style.borderColor = '#000';
                  btn.style.transform = 'translateY(-2px) scale(1.03)';
                }
              }
            }
          } catch (e) {}
        } catch (e) {
          console.warn('Failed to inject photocromatic color selector', e);
        }
      }
    });
  }

  parsePrice(product) {
    if (!product.variants || product.variants.length === 0) return 0;
    const variant = product.variants[0];
    if (variant.price) return parseFloat(variant.price);
    return 0;
  }

  getCurrentSelections() {
    const cfg = this.configurator && this.configurator.configuration
      ? this.configurator.configuration
      : (this.configurator.configuration = {});

    const raw = cfg.treatments;
    if (Array.isArray(raw)) {
      return raw.filter(Boolean);
    }
    if (typeof raw === 'string' && raw.trim()) {
      return [raw.trim()];
    }
    return [];
  }

  normalizeExistingSelection() {
    const cfg = this.configurator && this.configurator.configuration
      ? this.configurator.configuration
      : (this.configurator.configuration = {});

    const selections = this.getCurrentSelections();

    if (TEMP_SINGLE_SELECTION_MODE) {
      cfg.treatments = selections.length > 0 ? [selections[0]] : [];
    } else {
      cfg.treatments = selections;
    }
  }

  handleOptionSelect(card) {
    if (!card) return;

    if (!TEMP_SINGLE_SELECTION_MODE) {
      return LensConfiguratorStep.prototype.handleOptionSelect.call(this, card);
    }

    const key = card.dataset?.key;
    const type = card.dataset?.type || 'treatments';
    if (!key) return;

    const selections = this.getCurrentSelections();

    const isAlreadySelected = selections.includes(key);

    if (isAlreadySelected) {
      this.clearSelection(card, key);
      return;
    }

    if (selections.length >= 1) {
      this.showSingleSelectionWarning();
      return;
    }

    this.selectCard(card, type, key);
  }

  selectCard(card, type, key) {
    // Desactivar selección previa visualmente
    document.querySelectorAll(`[data-type="${type}"]`).forEach(other => {
      if (other === card) return;
      other.classList.remove('selected');
      other.removeAttribute('aria-selected');
    });

    card.classList.add('selected');
    card.setAttribute('aria-selected', 'true');

    const cfg = this.configurator.configuration;
    cfg.treatments = [key];

    if (key !== 'photocromatic') {
      delete cfg.photocromatic_color;
    }

    this.afterSelectionChange();
  }

  clearSelection(card, key) {
    card.classList.remove('selected');
    card.removeAttribute('aria-selected');

    const cfg = this.configurator.configuration;
    cfg.treatments = [];

    if (key === 'photocromatic') {
      delete cfg.photocromatic_color;
      const colorsWrap = card.querySelector('.photocromatic-colors');
      if (colorsWrap) {
        colorsWrap.style.display = 'none';
        colorsWrap.querySelectorAll('.photocromatic-color-btn').forEach(btn => {
          btn.style.borderColor = 'transparent';
          btn.style.transform = 'none';
        });
      }
    }

    this.afterSelectionChange();
  }

  afterSelectionChange() {
    try { this.configurator.calculatePrice(); } catch (e) {}
    try { this.configurator.updatePriceDisplay(); } catch (e) {}
    try { this.configurator.updateDrawerFooter(); } catch (e) {}
  }

  showSingleSelectionWarning() {
    const message = 'Por el momento solo puedes elegir un tratamiento. Quita el actual antes de seleccionar otro.';
    const manager = window.lensDrawerManager;

    if (manager && typeof manager.showModal === 'function') {
      if (document.getElementById('treatments-single-selection-modal')) return;
      manager.showModal.call(manager, {
        id: 'treatments-single-selection-modal',
        title: 'Configuración no disponible',
        message,
        buttonText: 'Entendido'
      });
      return;
    }

    alert(`Configuración no disponible\n\n${message}`);
  }
}

// Hacer disponible globalmente
window.TreatmentsStep = TreatmentsStep;
